import * as Preact from "preact"

import {Power, Element, Keyword} from "@fae/source/data/games/ember/views/Description.jsx"

export default [
    {
        "title": "Rolling",
        "color": "hotpink",
        "description": ({stage, unit}) => <span>At the start of each turn, regain 1 extra reroll.</span>,
        "onDraft": () => {
            window.extraRerolls = window.extraRerolls || 0
            window.extraRerolls += 1
        }
    },
    {
        "title": "Healing",
        "color": "hotpink",
        "description": ({stage, unit}) => <span>After each combat, restore 10 health to all units.</span>,
        "onDraft": () => {
            window.extraHealing = window.extraHealing || 0
            window.extraHealing += 10
        }
    },
    {
        "title": "Looting",
        "color": "hotpink",
        "description": ({stage, unit}) => <span>At each merchant, gain 10 extra silver.</span>,
        "onDraft": () => {
            window.extraGold = window.extraGold || 0
            window.extraGold += 10
        }
    },
    // {
    //     "title": "Tempo",
    //     "color": "red",
    //     "unitKey": "ashe",
    //     "description": ({stage, unit}) => <span>+<Power>10</Power> on the first turn.</span>,
    //     "powerboost": ({stage, unit}) => {
    //         if(stage.turn.number == 0) return +10
    //     }
    // },
    // {
    //     "title": "Counter",
    //     "color": "hotpink",
    //     "unitKey": "mara",
    //     "description": ({stage, unit}) => <span>+<Power>20</Power> during the enemy turn.</span>,
    //     "powerboost": ({stage, unit}) => {
    //         if(stage.turn.number % 2 == 1) return +20
    //     }
    // },
    // {
    //     "title": "Critical",
    //     "color": "hotpink",
    //     "unitKey": "kullervo",
    //     "description": ({stage, unit}) => <span>+<Power>30</Power> every 3rd attack.</span>,
    //     "powerboost": ({stage, unit}) => {
    //         if(unit == undefined) return
    //         if(unit.attackcount % 3 == 0) return +30
    //     }
    // },
]
